import type { Cache, ResolveInfo } from '@urql/exchange-graphcache';
import {
  EVENT_LIST_CACHE_FIELDS,
  ORGANIZATION_PEOPLE_CACHE_FIELDS,
} from '@/client/exchanges/cacheExchange/constants';
import { queueEventListReset } from '@/client/exchanges/cacheExchange/eventListResetQueue';
import invalidateFields from '@/client/exchanges/cacheExchange/invalidateFields';

export default function insert_event_one(
  parent: {
    insert_event_one?: {
      datetime?: string | null;
      parent_id?: string | null;
    } | null;
  },
  _args: unknown,
  cache: Cache,
  _info: ResolveInfo,
) {
  invalidateFields(
    [...EVENT_LIST_CACHE_FIELDS, ...ORGANIZATION_PEOPLE_CACHE_FIELDS],
    cache,
  );

  queueEventListReset({
    datetime: parent.insert_event_one?.datetime,
    parentEventId: parent.insert_event_one?.parent_id,
  });
}
